/// <reference types="@angular/localize" />


import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function bootstrapApp() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

if (window.top !== window.self) {
  console.error('This application cannot be run inside an iframe.');
  document.body.innerHTML = '<h1>Access Denied</h1><p>Diese Anwendung kann nicht innerhalb eines iFrames genutzt werden.</p>';
} else {
  bootstrapApp();
}


if (environment.production) {

}
